import { Box, Button } from "@mui/material";
import styled from "styled-components";
import pallet from "../../../layouts/pallet";

export const HeaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between'
});

export const StyledButton = styled(Button).attrs({
  color: "primary",
  variant: "contained"
})({})

export const SearchContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  width: '100%',
  alignItems: 'flex-end',
}));

export const ButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  gap: 16
})

export const AddWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
})

export const DateWrapper = styled(Box)({
  flex: 1,
  '.css-7a03z5-MuiFormControl-root': {
    width: '100%'
  }
})

export const profileImgStyle = {
  width: 34,
  height: 34,
  borderRadius: '50%',
  objectFit: 'cover',
  background: pallet.lightGrey
} as React.CSSProperties;

export const EditModalWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 2
})

export const ProfileWrapper = styled(Box)({
  display: 'flex',
  gap: 16,
  backgroundColor: pallet.disabled,
  borderRadius: 4,
  padding: 8,
  alignItems: 'center'
})

export const AbsentStatusWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  color: pallet.red2,
});

export const InactiveBadge = styled(Box)({
  backgroundColor: '#FFEBEB',
  color: `${pallet.red2}`,
  borderRadius: '16px',
  padding: '2px 8px',
  fontSize: '10px',
  fontWeight: 600,
  lineHeight: '12px',
  display: 'flex',
  alignItems: 'center',
})

